import { Popover as AntPopover } from 'antd'
import { ComponentProps } from 'react'
import * as React from 'react'

const KPopover: React.FC<ComponentProps<typeof AntPopover>> = ({
  title,
  placement = 'topLeft',
  ...others
}) => {
  return (
    <AntPopover
      title={title && <h5 className="mb-0">{title as React.ReactNode}</h5>}
      placement={placement}
      {...others}
    />
  )
}

export default KPopover
